import L from "./_Stack.js";
import B from "./_arrayEach.js";
import I from "./_assignValue.js";
import O from "./_baseAssign.js";
import _ from "./_baseAssignIn.js";
import M from "./_cloneBuffer.js";
import w from "./_copyArray.js";
import D from "./_copySymbols.js";
import G from "./_copySymbolsIn.js";
import N from "./_getAllKeys.js";
import U from "./_getAllKeysIn.js";
import h from "./_getTag.js";
import x from "./_initCloneArray.js";
import l from "./_initCloneByTag.js";
import K from "./_initCloneObject.js";
import P from "./isArray.js";
import R from "./isBuffer.js";
import W from "./isMap.js";
import Y from "./isObject.js";
import q from "./isSet.js";
import H from "./keys.js";
import J from "./keysIn.js";
var Q = 1, V = 2, X = 4, s = "[object Arguments]", Z = "[object Array]", $ = "[object Boolean]", z = "[object Date]", u = "[object Error]", d = "[object Function]", k = "[object GeneratorFunction]", v = "[object Map]", rr = "[object Number]", E = "[object Object]", or = "[object RegExp]", tr = "[object Set]", ir = "[object String]", nr = "[object Symbol]", er = "[object WeakMap]", fr = "[object ArrayBuffer]", ar = "[object DataView]", mr = "[object Float32Array]", gr = "[object Float64Array]", pr = "[object Int8Array]", cr = "[object Int16Array]", br = "[object Int32Array]", Tr = "[object Uint8Array]", jr = "[object Uint8ClampedArray]", yr = "[object Uint16Array]", Ar = "[object Uint32Array]", o = {};
o[s] = o[Z] = o[fr] = o[ar] = o[$] = o[z] = o[mr] = o[gr] = o[pr] = o[cr] = o[br] = o[v] = o[rr] = o[E] = o[or] = o[tr] = o[ir] = o[nr] = o[Tr] = o[jr] = o[yr] = o[Ar] = !0;
o[u] = o[d] = o[er] = !1;
function b(r, f, a, F, g, i) {
  var t, p = f & Q, c = f & V, C = f & X;
  if (a && (t = g ? a(r, F, g, i) : a(r)), t !== void 0)
    return t;
  if (!Y(r))
    return r;
  var T = P(r);
  if (T) {
    if (t = x(r), !p)
      return w(r, t);
  } else {
    var m = h(r), j = m == d || m == k;
    if (R(r))
      return M(r, p);
    if (m == E || m == s || j && !g) {
      if (t = c || j ? {} : K(r), !p)
        return c ? G(r, _(t, r)) : D(r, O(t, r));
    } else {
      if (!o[m])
        return g ? r : {};
      t = l(r, m, p);
    }
  }
  i || (i = new L());
  var y = i.get(r);
  if (y)
    return y;
  i.set(r, t), q(r) ? r.forEach(function(n) {
    t.add(b(n, f, a, n, r, i));
  }) : W(r) && r.forEach(function(n, e) {
    t.set(e, b(n, f, a, e, r, i));
  });
  var S = C ? c ? U : N : c ? J : H, A = T ? void 0 : S(r);
  return B(A || r, function(n, e) {
    A && (e = n, n = r[e]), I(t, e, b(n, f, a, e, r, i));
  }), t;
}
export {
  b as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseClone.js
// module id = 1467
// module chunks = 67